/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerListChangesQueryResponse, ComparisonsControllerListChangesPathParams, ComparisonsControllerListChangesQueryParams, ComparisonsControllerListChanges401, ComparisonsControllerListChanges403 } from "../../models/comparisonsController/ComparisonsControllerListChanges";

function getComparisonsControllerListChangesUrl(id: ComparisonsControllerListChangesPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/comparisons/${id}/changes` as const }  
  return res
}

/**
 * @description Returns a paginated list of changes for the given comparison. Supports filtering via filter[changeType]=EDIT and full-text search via search=term (searches analysisTitle and analysis). Sort via sort=orderIndex or sort=-orderIndex. Paginate via page[number]=1&page[size]=20. Meta includes standard pagination fields plus reviewedCount (assessed changes across the full comparison).
 * @summary List changes for a comparison
 * {@link /api/v1/comparisons/:id/changes}
 */
export async function comparisonsControllerListChanges(id: ComparisonsControllerListChangesPathParams["id"], params?: ComparisonsControllerListChangesQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerListChangesQueryResponse, ResponseErrorConfig<ComparisonsControllerListChanges401 | ComparisonsControllerListChanges403>, unknown>({ method : "GET", url : getComparisonsControllerListChangesUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}